import Privacy from './PrivacyPolicy'; 

export default Privacy;